import React, { Component } from "react";
import HttpService from "../../../service/shared/HttpService";
import { connect } from "react-redux";
import CreditCard from "./payment-options/credit-card/CreditCard";
import PaymentOption from "./payment-options/PaymentOption";
import TravelBank from "./payment-options/travel-bank/TravelBank";
import "./Payment.css";
import FloCashPaymentOptions from "./payment-options/flocash/FloCashPaymentOptions";
import { paymentAction } from "../../../redux/actions/booking/paymentAction";
import ProgressSimpler from "../../shared/progress-simple/ProgressSimpler";
import UnionPay from "./payment-options/union-pay/UnionPay";
import HoldReservation from "./payment-options/hold-reservation/HoldReservation";
import Loading from "../seat-selection/Loading";
class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creditCardOptions: [],
      flocashOptions: [],
      priceInfo: null,
      unionPay: null,
      travelBank: null,
      holdReservation: null,
      selectedPaymentOption: "",
      isLoading: false,
    };
    this.setSelectedPaymentOption = this.setSelectedPaymentOption.bind(this);
  }

  componentDidMount() {
    window.scrollTo({ top: 0, behavior: "smooth" });

    
    let countryCode = "ET";
    let airportCode =
      this.props.searchFlight.searchResult.data.searchResponse.brandedResults
        .itineraryPartBrands[0][0].itineraryPart.segments[0].origin;
    let departureDate =
      this.props.searchFlight.searchResult.data.searchResponse.brandedResults
        .itineraryPartBrands[0][0].departure;
    let cookieSabreDataRequest =
      this.props.searchFlight.searchResult.data.cookieSabreDataRequest;
    let token = this.props.searchFlight.token;
    let requestObject = {
      IsToday: false,
      IsFlightWithIn48Hours: false,
      CountryCode: countryCode,
      AirportCode: airportCode,
      DepartureDateTime: departureDate,
      //"PromoCode": "DOM71",
      paymentType: 0,
      cookieSabreDataRequest: cookieSabreDataRequest,
    };
    this.setState({ isLoading: true });
    HttpService.postService(
      requestObject,
      "/PaymentOption/GetPaymentOption",
      token
    ).then((response) => {
      
      this.setState({ isLoading: false });
      this.constructPaymentOptioins(response.data.payment.paymentProducts);
      
      if (this.props.countryList.length === 0) {
        this.getCountryList(token);
      }
    });
  }
  getCountryList(token) {
    
    HttpService.getCountryListService(
      "/_masterdatasvc-masterdata/api/Country/list?memoryCachRefresh=true",
      "",
      token
    ).then((response) => {
      this.props.saveCountryList(response.data.lstCountriesDetail);
      
    });
  }
  setSelectedPaymentOption(option) {
    
    this.setState({ selectedPaymentOption: option });
  }
  renderPaymentOption() {
    if (this.state.selectedPaymentOption === "AFOP") {
      return (
        <FloCashPaymentOptions
          flocashOptions={this.state.flocashOptions}
          amount={this.state.priceInfo}
        />
      );
    }
    if (this.state.selectedPaymentOption === "TB") {
      return <TravelBank />;
    }
    if (this.state.selectedPaymentOption === "CC") {
      return (
        <CreditCard
          creditCardOptions={this.state.creditCardOptions}
          countryList={this.props.countryList}
        />
      );
    }
    if (this.state.selectedPaymentOption === "UP") {
      return <UnionPay unionPay={this.state.unionPay} />;
    }
    if (this.state.selectedPaymentOption === "HR") {
      return <HoldReservation />;
    }
  }
  constructPaymentOptioins(paymentOptions) {
    
    this.setState({
      creditCardOptions: [],
      flocashOptions: [],
      unionPay: null,
    });
    let creditCardOptionList = [];
    let flocashOptionList = [];

    paymentOptions.forEach((paymentOption) => {
      if (paymentOption.paymentInfo.paymentType == "AFOP") {
        paymentOption.paymentInfo.afopDetails.forEach((afop) => {
          if (afop.fopCode === "BR") {
            this.setState({ unionPay: afop });
          } else {
            flocashOptionList.push(afop);
          }
        });
        
        this.setState({
          flocashOptions: flocashOptionList,
          priceInfo: paymentOption.paymentInfo.amount,
        });
      }
      if (paymentOption.paymentInfo.paymentType == "CREDIT_CARD") {
        creditCardOptionList.push(paymentOption);
      }
      if (paymentOption.paymentInfo.paymentType == "TRAVEL_BANK") {
        this.setState({ travelBank: paymentOption.paymentInfo });
      }
      if (
        paymentOption.paymentInfo.paymentType == "REMOTE" &&
        paymentOption.paymentInfo.paymentCode == "BA_remote"
      ) {
        this.setState({ holdReservation: paymentOption.paymentInfo });
      }
    });
    this.setState({ creditCardOptions: creditCardOptionList });
  }

  render() {
    //if(this.state.isLoading)
    //{
    //    return(<div className="container text-center"><ProgressSimpler /></div>);
    //}

    return (
      <div className="container mt-3">
        {this.state.isLoading ? (
          <Loading />
        ) : (
          <PaymentOption
            paymentInfo={this.state}
            setSelectedPaymentOption={this.setSelectedPaymentOption}
          />
        )}
        {this.renderPaymentOption()}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    searchFlight: state.searchFlight,
    countryList: state.payment.countryList,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    saveCountryList: (countryList) => {
      dispatch({
        type: paymentAction.SAVECOUNTRYLIST,
        data: countryList,
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Payment);
